import { Slider } from "@upstageai/ui";

import { parsingTableStore } from "../../utils/mobx/ParsingTableStore";

export function ConfidenceScoreSlider(): JSX.Element {
  const { confidenceThreshold, setConfidenceThreshold } = parsingTableStore;

  const handleValueChange = (values: number[]) => {
    const newValue = values[0];
    setConfidenceThreshold(newValue / 100);
  };

  return (
    <Slider
      value={[confidenceThreshold * 100]}
      onValueChange={handleValueChange}
      aria-label="confidence-score"
      min={0}
      max={100}
      step={1}
      className="w-full"
    />
  );
}
